import gql from "graphql-tag";
import { VARIANT_FRAGMENT_FOR_CART } from "@src/pages/Cart/queries";

export const ORDER_FOR_GA_PURCHASE = gql`
  ${VARIANT_FRAGMENT_FOR_CART}
  fragment orderForGaPurchase on Order {
    id
    paymentType
    total {
      gross {
        amount
        currency
      }
      tax {
        amount
      }
      currency
    }
    shippingPrice {
      gross {
        amount
      }
    }
    voucher {
      id
      name
    }
    discountAmount {
      amount
    }
    usedPoint {
      amount
    }
    totalCaptured {
      amount
    }
    subs {
      codAmount {
        amount
      }
      seller {
        name
      }
      lines {
        id
        productName
        quantity
        brand
        productSku
        unitPrice {
          gross {
            amount
          }
          tax {
            amount
          }
        }
        variant {
          ...variantForCart
        }
        isCanceled
      }
    }
  }
`;
